export default {
  home: [
    {
      selector: '.study-time',
      content: '用户总共学习时长，单位为：分钟。'
    },
    {
      selector: '.last-7-days',
      content: '此处可查看最近七天内每天的学习时长。'
    },
    {
      selector: '.heatmap',
      content: '此处展示最近200天内每天学习课程数，课程数越多，颜色越深。'
    },
    {
      selector: '.progress',
      content: '展示当前学习总的进度，并可点击右下角按钮进入当前需要学习的课程'
    },
    {
      selector: '.first-can-learn-chapter',
      content: '课程章节，可点击标题展开查看本章节所有的内容',
    },
    {
      selector: '.first-lesson',
      content: '当前课程可直接进入学习'
    },
    {
      selector: '.second-lesson',
      content: '当前课程为锁定状态，只有关联课程学习完成过后才可以学习'
    }
  ],
  lesson: [
    {
      selector: '.article',
      content: '文章正文',
    },
    {
      selector: '.exercise',
      content: '练习题'
    },
    {
      selector: '.exercise-action',
      content: '点击按钮开始做题，按钮点击后会将练习题的默认代码复制到右侧的代码编辑框',
      action: (node) => {
        setTimeout(() => {
          const button = node.querySelector('button');
          if (button) {
            button.click();
          }
        }, 1000);
      }
    },
    {
      selector: '.chapter-catalog',
      content: '点击此按钮显示当前章节的目录信息'
    },
    {
      selector: '.prev-lesson',
      content: '点击此按钮查看上一节课程内容'
    },
    {
      selector: '.next-lesson',
      content: '点击此按钮开始下一节课程的学习，只有当前小节文章阅读完成且所有练习题回答正确才能进入下一节课程的学习'
    },
    {
      selector: '.code-editor',
      content: '代码编辑框，支持的语言类型为Python3'
    },
    {
      selector: '.terminal',
      content: '代码执行后输出的地方'
    },
    {
      selector: '.code-runner',
      content: '点击此按钮运行代码，若代码执行次数≥3此，则在练习题下方会展示正确答案'
    },
    {
      selector: '.code-debugger',
      content: '点击此按钮查看代码执行流程'
    },
    {
      selector: '.code-reset',
      content: '点击此按钮重置编码编辑框中的代码，如果当前正在完成某个练习题，则重置为练习题的默认代码'
    },
    {
      selector: '.exercise-tips',
      content: '在完成某个练习题时会显示这个提示标签，点击标签右侧的"关闭"按钮则会退出完成练习题的状态'
    }
  ]
}
